<template>
  <div class="dingding-menu">
    <div v-for="item in data" :key="item.id" @click="skipLick(item.path)">
      <img :src="item.url" />
      <div>{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { jurisdiction } from '../api/home';
import store from '../store';
import * as dd from 'dingtalk-jsapi';
import menuData from '../config/menu';

Vue.use(Toast);

export default {
  data() {
    return {
      data: [],
      path: '',
    };
  },
  mounted() {
    // 后期菜单超过5个结合后端优化
    let { menu } = this.$store.state;
    if (!menu) {
      // 机器人钉钉暂时写死为pact（合同管理），后期拓展再放开
      // const res = await jurisdiction().catch(err => {
      //   if (err.message) Toast.fail(err.message);
      //   return false;
      // });
      // if (res) {
      // store.commit('setMenu', res);
      menu = ['pact'];
      // } else {
      //   window.sessionStorage.setItem('dingdingAuth', '');
      //   window.localStorage.setItem('dingdingAuthToken', '');
      //   Toast('登陆失败 请退出重新登陆');
      // }
    }
    (menu || []).forEach(r => {
      if (menuData[r]) this.data.push(menuData[r]);
    });
  },
  methods: {
    skipLick(path) {
      // 两种跳转选择
      if (path.includes('http')) {
        dd.biz.util.openLink({
          url: `${path}?token=${window.sessionStorage.getItem('dingdingAuth')}`,
        });
        return;
        // return this.$router.push({path: '/common/iframe',query:{src:path,version: Date.now()}});
      }
      this.$router.push({ path, query: { version: Date.now() } });
    },
  },
};
</script>
<style lang="scss">
.dingding-menu {
  display: flex;
  padding: 40px 25px;
  flex-wrap: wrap;
  > div {
    width: 140px;
    font-size: 26px;
    color: #81888f;
    text-align: center;
    padding-bottom: 40px;
    img {
      width: 94px;
      border-radius: 100px;
    }
  }
}
</style>
